import { render, staticRenderFns } from "./DataDeletion.vue?vue&type=template&id=3db8b2c6&"
import script from "./DataDeletion.vue?vue&type=script&lang=js&"
export * from "./DataDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports